import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Pagination } from 'semantic-ui-react';
import { wrapConsumer } from '../FilteringContextProvider';
import { filterStateType, filterPropsType } from '../../../types';
import CommonSelectInputWrapper from '../../common/CommonSelectInputWrapper';
import { Formik } from 'formik';
import { withTranslation } from 'react-i18next';

const OverviewFooter = ({
  filterState,
  handleFilterStateChanged,
  setAllRowsSelected,
  filterProps,
  renderRecordsPerPage,
  renderSelectedRowsCounter,
  selectedRows,
  renderSelection,
  t
}) => {
  const { filteredList } = filterProps;
  return (
    <Grid.Row columns={2} className="notPaddedSegment">
      <Grid.Column style={{ padding: '5px 0 0 0' }}>
        <SelectRecordsPerPage
          renderRecordsPerPage={renderRecordsPerPage}
          pageSize={filterState.pageSize}
          selectedRows={selectedRows}
          renderSelection={renderSelection}
          renderSelectedRowsCounter={renderSelectedRowsCounter}
          onPageSizeChange={value => {
            handleFilterStateChanged({ pageSize: value, page: 1 });
            setAllRowsSelected(false);
          }}
          totalElements={filteredList.totalElements}
          t={t}
        />
      </Grid.Column>
      <Grid.Column style={{ padding: '0 0 5px 0' }}>
        <Pagination
          key="paginationFooter"
          name="paginationFooter"
          activePage={filterState.page}
          totalPages={filteredList.totalPages}
          size="mini"
          floated="right"
          pointing
          secondary
          onPageChange={(e, data) => {
            handleFilterStateChanged({ page: data.activePage });
            setAllRowsSelected(false);
          }}
        />
      </Grid.Column>
    </Grid.Row>
  );
};

OverviewFooter.propTypes = {
  filterState: filterStateType.isRequired,
  handleFilterStateChanged: PropTypes.func.isRequired,
  filterProps: filterPropsType.isRequired,
  renderRecordsPerPage: PropTypes.bool
};

OverviewFooter.defaultProps = {
  renderRecordsPerPage: true
};

const SelectRecordsPerPage = ({
  renderRecordsPerPage,
  pageSize,
  onPageSizeChange,
  totalElements,
  selectedRows,
  renderSelection,
  renderSelectedRowsCounter,
  t
}) => {
  let selectedRowsCounter = selectedRows ? Object.keys(selectedRows).length : 0;

  const pageSizeOption = [
    { key: '10', value: 10, text: '10' },
    { key: '20', value: 20, text: '20' },
    { key: '100', value: 100, text: '100' }
  ];

  return (
    <>
      {renderRecordsPerPage && (
        <div className="displayInlineBlock componentWithRightMargin" style={{ width: '60px' }}>
          <Formik
            render={formikProps => (
              <CommonSelectInputWrapper
                {...formikProps}
                name="pageSize"
                value={pageSize}
                options={pageSizeOption}
                onChange={(e, value) => {
                  onPageSizeChange(value);
                }}
              />
            )}
          />
        </div>
      )}
      <div className="displayInlineBlock footerTotalElements">
        {t('table.total.elements', { totalElements })}
        {renderSelection &&
          renderSelectedRowsCounter &&
          t('table.selected.elements', { selectedRowsCounter })}
      </div>
    </>
  );
};

SelectRecordsPerPage.propTypes = {
  renderRecordsPerPage: PropTypes.bool,
  pageSize: PropTypes.number.isRequired,
  onPageSizeChange: PropTypes.func.isRequired,
  totalElements: PropTypes.number
};

SelectRecordsPerPage.defaultProps = {
  renderRecordsPerPage: true,
  renderSelectedRowsCounter: true,
  totalElements: 0
};

export default withTranslation()(wrapConsumer(OverviewFooter));
